import { render, staticRenderFns } from "./TripTagView.vue?vue&type=template&id=117f71f0"
import script from "./TripTagView.vue?vue&type=script&lang=js"
export * from "./TripTagView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports